import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M14.2364 4.11659C15.8068 5.16131 16.8918 6.7958 17.2528 8.66048C17.6138 10.5252 17.2213 12.4673 16.1615 14.0597"
      stroke={fill}
      strokeWidth="3"
      strokeLinecap="round"
    />
  </g>
);

export default Icon;
